module.exports = {
  isDev: process.env.NODE_ENV === 'development' ? true : false,
  baseURL:
    process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_API_BASE_URL || ''
      : '',
  contentType: 'application/json;charset=UTF-8',
  requestTimeout: 90000,
  successCode: [200, 0, '200', '0'],
  statusName: 'code',
  messageName: 'msg',
}
